import { gql } from '@apollo/client';

import graphQLRequester from '../../request/GraphQLRequester';

export class GraphQLHomeRequester {
  public getHomeSummaryVehicles = (groupIds?: string[]): Promise<number> =>
    graphQLRequester
      .query<{ homeSummaryVehicles: number }>({
        query: gql`
          query GetHomeSummaryVehicles($groupIds: [String]) {
            homeSummaryVehicles(groupIds: $groupIds)
          }
        `,
        variables: { groupIds },
      })
      .then((result) => result.homeSummaryVehicles);

  public getHomeSummaryGeofences = (): Promise<number> =>
    graphQLRequester
      .query<{ homeSummaryGeofences: number }>({
        query: gql`
          query GetHomeSummaryGeofences {
            homeSummaryGeofences
          }
        `,
      })
      .then((result) => result.homeSummaryGeofences);
}

export default GraphQLHomeRequester;
